$(document).ready(function () {
  // Find the first .item with a data-image attribute
  const firstWithImage = $('.item').filter(function () {
    return $(this).data('image');
  }).first();

  // Set initial image if available
  const initialImage = firstWithImage.data('image');
  if (initialImage) {
    $('.img img').attr('src', initialImage).addClass('hovered');
  }

  // On hover of any .item
  $('.item').hover(function () {
    const newImage = $(this).data('image');
    if (newImage) {
      $('.img img').attr('src', newImage).addClass('hovered');
    }
  });
});
